module.exports = __webpack_public_path__ + "img/messageiq-diamond.a84963e2.png";